export const VIRTUAL_TOUR_SECTION_ID = 'virtual-tour';

export const scrollToVirtualTour = () => {
  if (typeof document === 'undefined') return;

  document.getElementById(VIRTUAL_TOUR_SECTION_ID)?.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
};
